import React from 'react';
import { SignIn, useAuth } from '@clerk/clerk-react';
import { Navigate } from 'react-router-dom';
import './SignInPage.css';

function SignInPage() {
  const { isSignedIn, isLoaded } = useAuth();

  // Gia' loggata: niente card vuota, vai dritta in dashboard.
  if (isLoaded && isSignedIn) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="sign-in-page">
      <div className="auth-container">
        <div className="auth-card">
          <h1>Accedi a FesteDaPiccoli</h1>
          <p>Accedi per gestire i tuoi servizi e messaggi</p>
          <SignIn
            fallbackRedirectUrl="/dashboard"
            signUpUrl="/registrazione"
            routing="path"
            path="/accedi"
          />
          <div className="auth-footer">
            <p>Non sei ancora registrato? <a href="/registrazione">Iscriviti come provider</a></p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignInPage;
